import React, { useState, useCallback, useEffect } from "react";
import { Dialog, DialogContent, Slide, useTheme } from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';

// Transition component for dialog
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

/**
 * @component IframeDialog
 * @description Reusable dialog component for iframe-based modals
 * @param {boolean} open - Controls dialog visibility
 * @param {string} frameUrl - URL for the iframe
 * @param {Function} onClose - Callback when iframe sends completion message
 * @param {string} iframeId - Unique ID for the iframe element
 * @param {string} title - Title attribute for the iframe
 */
const IframeDialog = ({open, frameUrl, onClose, iframeId, title}) => {
    const [loaded, setLoaded] = useState(false);
    const theme = useTheme();
    const loadHandler = useCallback(() => setLoaded(true), []);
    const closeHandler = useCallback(() => onClose(null), [onClose]);
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    
    useEffect(() => {
        let listener = null;

        if (loaded && !listener) {
            const childWindow = document.getElementById(iframeId).contentWindow;
            listener = message => {
                if (message.source !== childWindow) {
                    return; // Skip message in this event listener
                }

                if (message.data.status === "complete") {
                    if (onClose) {
                        onClose(message.data)
                    }
                }
            };

            window.addEventListener('message', listener, false);
        }

        return () => {
            if (listener) {
                window.removeEventListener('message', listener, false);
            }
        };
    }, [loaded, iframeId]);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={closeHandler}
            aria-labelledby={`${iframeId}-dialog-title`}
            aria-describedby={`${iframeId}-dialog-description`}
            fullWidth={true}
            className="accountFrameDialog"
            fullScreen={fullScreen}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <iframe 
                    id={iframeId}
                    onLoad={loadHandler} 
                    src={frameUrl} 
                    title={title}
                    allow="publickey-credentials-get; clipboard-read; clipboard-write *"
                />
            </DialogContent>
        </Dialog>
    );
};

export default IframeDialog; 